import FieldInput from "./FieldInput";

import { AbsDropDown, Button, COLORS, Input, Label, Modal } from "abs-ui-components";
const DynamicSection = ({
    title,
    addLabel,
    fields,
    rows,
    errors,
    errorPrefix,
    onAddRow,
    onRemoveRow,
    onChangeCell,
    disabled,
}) => {
    const gridTemplate = `repeat(${fields.length}, 1fr) 44px`;

    return (
        <div
            className="mb-4"
            style={{
                border: "1px solid #d7dee8",
                borderRadius: 6,
                //overflow: "hidden",
                background: "#fff",
            }}
        >

            <div
                className="d-flex"
                style={{
                    padding: "10px 14px",
                    background: "#002A4E",
                    borderBottom: "1px solid #d7dee8",

                }}
            >
                <div className="d-flex flex-column" >
                    <Label name={title} bold size="md" labelColor="#ffffff" />
                </div>
                <span className="ml-auto">
                    <Button
                        className="ml-2"
                        size="sm"
                        onClick={onAddRow}
                        disabled={disabled}
                        style={{ whiteSpace: "nowrap", display: "inline-block" }}
                    >
                        {addLabel}
                    </Button>
                </span>
            </div>

            {/* Body */}
            <div style={{ padding: 14 }}>
                {/* Column headings */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: gridTemplate,
                        gap: 8,
                        marginBottom: 6,
                    }}
                >
                    {fields.map((f) => (
                        <div key={f.name}>
                            <Label name={f.label} bold />
                        </div>
                    ))}
                    <div />
                </div>

                {/* Data rows */}
                {rows.map((row, index) => (
                    <div
                        key={row.id}
                        style={{
                            display: "grid",
                            gridTemplateColumns: gridTemplate,
                            gap: 6,
                            alignItems: "start",  
                            padding: "4px 0",
                        }}
                    >
                        {fields.map((f) => {
                            const errKey = errorPrefix
                                ? `${errorPrefix}[${index}].${f.name}`
                                : null;
                            const cellError = errKey ? errors?.[errKey] : null;

                            return (
                                <div key={f.name}>
                                    <FieldInput
                                        field={f}
                                        row={row}
                                        value={row[f.name]}
                                        error={cellError}
                                        disabled={disabled}
                                        onChange={(name, val) => {
                                            onChangeCell(index, name, val);
                                        }}
                                    />
                                </div>
                            );
                        })}
                        {/* remove button */}
                        <div className="d-flex justify-content-center">
                            <Button
                                size="sm"
                                color="danger"
                                onClick={() => onRemoveRow(index)}
                                disabled={disabled || rows.length === 1}
                            >
                                ✕
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DynamicSection